// import { Price } from "./price";
// import Image from "next/image";
// import { AddToCart } from "./add-to-cart";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Product } from "../types";
import { cn } from "@/lib/utils";

function getBaseUrl() {
  const parsedUrl = new URL(window?.location?.href);
  const pathname = parsedUrl.pathname;
  const segments = ["/products", "/collections", "/cart"];
  const firstSegmentIndex = segments.reduce((acc, segment) => {
    const index = pathname.indexOf(segment);
    return index !== -1 && index < acc ? index : acc;
  }, pathname.length);
  const baseUrl = `${pathname.substring(0, firstSegmentIndex)}`;
  return baseUrl;
}

export default function ProductCard({
  product,
  className,
}: {
  product: Product;
  className?: React.ComponentProps<typeof Card>["className"];
}) {
  return (
    <a
      href={`${getBaseUrl()}/products/${product.handle}`}
      className="hp-cursor-pointer"
    >
      <Card
        data-helium-name="product-item"
        data-helium-product-handle={product.handle}
        className={cn("hp-w-full hp-overflow-hidden", className)}
      >
        <div className="hp-group hp-relative hp-overflow-hidden">
          <img
            src={product?.featuredImage?.url || product.image}
            alt="Product Image"
            className="hp-mx-auto hp-h-full hp-w-full hp-object-contain hp-object-top"
            loading="eager"
            width={200}
            height={200}
          />
          <div className="absolute inset-0 bg-black bg-opacity-0 transition-opacity duration-300 group-hover:bg-opacity-20" />
          <div className="hp-absolute hp-right-2 hp-top-2">
            <Button size="icon" variant="secondary" aria-label="Find Similar">
              <Similar />
            </Button>
          </div>
          {/*
        <div className="hp-absolute hp-bottom-2 hp-right-2">
          <AddToCart product={product} />
        </div>
        */}
        </div>
        <CardContent className="hp-p-2">
          <h4 className="hp-mt-2 hp-line-clamp-1 hp-text-left hp-text-sm hp-font-semibold">
            {product.title}
          </h4>
          {/*
        <Price
          amount={product.priceRange.maxVariantPrice.amount}
          currencyCode={product.priceRange.maxVariantPrice.currencyCode}
          className="hp-w-fit hp-text-xs hp-font-medium"
        />
        */}
        </CardContent>
      </Card>
    </a>
  );
}
export function Similar() {
  return (
    <svg
      width="148"
      height="40"
      viewBox="0 0 148 95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M46.629 12.5086L9.69876 19.0204C4.59975 19.9195 1.19505 24.7819 2.09414 29.8809L11.8618 85.2763C12.7609 90.3753 17.6234 93.78 22.7224 92.8809L59.6527 86.3691C64.7517 85.47 68.1564 80.6076 67.2573 75.5086L57.4896 20.1132C56.5905 15.0142 51.7281 11.6095 46.629 12.5086Z"
        fill="#E0E0E0"
        stroke="black"
        stroke-width="2.8125"
      />
      <path
        d="M138.301 19.0204L101.371 12.5086C96.2719 11.6095 91.4095 15.0142 90.5104 20.1132L80.7427 75.5086C79.8436 80.6076 83.2483 85.4701 88.3473 86.3691L125.278 92.881C130.377 93.78 135.239 90.3753 136.138 85.2763L145.906 29.8809C146.805 24.7819 143.4 19.9195 138.301 19.0204Z"
        fill="#E0E0E0"
        stroke="black"
        stroke-width="2.8125"
      />
      <path
        d="M92.75 5.25H55.25C50.0723 5.25 45.875 9.44733 45.875 14.625V80.25C45.875 85.4277 50.0723 89.625 55.25 89.625H92.75C97.9277 89.625 102.125 85.4277 102.125 80.25V14.625C102.125 9.44733 97.9277 5.25 92.75 5.25Z"
        fill="#999999"
        stroke="black"
        stroke-width="2.8125"
      />
    </svg>
  );
}
